import { call, put, take } from 'redux-saga/effects';
import commands from 'dmpconnectjsapp-base/actions/config/commands';
import { apiSections }                                                              from 'dmpconnectjsapp-base/constants';
import { dmpCommandFailureContextualizedType, dmpCommandSuccessContextualizedType } from 'dmpconnectjsapp-base/actions';
import { formatSetPersistantDataParams }                                            from 'dmpconnectjsapp-base/actions/config/commandParamsFormatters';
import moment from 'moment';
import { getAction }                                      from '../actions';
import { b64DecodeUnicode, b64EncodeUnicode, generateId } from '../utils/dataUtils';

export function* getPersistantData(reason, callId) {
  yield put(getAction(
    commands.getPersistantData,
    apiSections.GET_PERSISTANT_DATA,
    undefined,
    {
      synchronous: true,
      contextExtra: { reason, callId }
    },
  ));
  
  let result;
  while (!result) {
    const getPersistantDataResult = yield take(
      [
        dmpCommandSuccessContextualizedType(apiSections.GET_PERSISTANT_DATA),
        dmpCommandFailureContextualizedType(apiSections.GET_PERSISTANT_DATA),
      ],
    );
    
    const { context: { callId: resultCallId } } = getPersistantDataResult;
    if (resultCallId === callId) {
      result = getPersistantDataResult;
    }
  }
  
  return result;
}

export function* saveStatInPersistantData(action) {
  const { data: { s_persistantData64 } } = yield call(getPersistantData, 'saveStats', generateId(20));
  let alim;
  let consult;
  let startDate;
  let persistantDataRest;
  let efficienceDataRest;
  try {
    const currentData = s_persistantData64 ? JSON.parse(b64DecodeUnicode(s_persistantData64)) : {};

    const {
      efficience: {
        statistics: {
          alim: persistedAlim = 0,
          consult: persistedConsult = 0,
          startDate: persistedStartDate = moment().format('YYYYMMDD'),
        } = {},
        ...efficienceData
      } = {},
      ...persistantData
    } = currentData;

    alim = persistedAlim;
    consult = persistedConsult;
    startDate = persistedStartDate;
    persistantDataRest = persistantData;
    efficienceDataRest = efficienceData;
  } catch (e) {
    alim = 0;
    consult = 0;
    startDate = moment().format('YYYYMMDD');
    persistantDataRest = null;
    efficienceDataRest = null;
  }

  yield put(getAction(
    commands.setPersistantData,
    apiSections.SET_PERSISTANT_DATA,
    formatSetPersistantDataParams(b64EncodeUnicode(JSON.stringify({
      ...persistantDataRest,
      efficience: {
        statistics: {
          alim: action.type === dmpCommandSuccessContextualizedType(apiSections.SEND_DOCUMENT_SECTION) ? alim + 1 : alim,
          consult: dmpCommandSuccessContextualizedType(apiSections.DOCUMENT_CONTENT_SECTION) ? consult + 1 : consult,
          startDate,
        },
        ...efficienceDataRest,
      },
    }))),
    {
      synchronous: true,
      contextExtra: { 'reason': 'saveStats' }
    },
  ));
}
